import React, { useState } from "react";
import { Table, Input, Button, DatePicker, Space, Typography } from "antd";
import moment from "moment";

const { RangePicker } = DatePicker;
const { Title } = Typography;

const SuperAdminPage = () => {
    const [data, setData] = useState([
        {
            key: "1",
            name: "John Doe",
            phone: "+1234567890",
            email: "johndoe@example.com",
            college: "ABC University",
        },
        {
            key: "2",
            name: "Jane Smith",
            phone: "+9876543210",
            email: "janesmith@example.com",
            college: "XYZ College",
        },
        // Add more mock data as needed
    ]);

    const [filteredData, setFilteredData] = useState(data);
    const [dateRange, setDateRange] = useState([]);

    // Handle date filtering
    const handleDateFilter = (dates) => {
        if (dates) {
            const [start, end] = dates;
            setDateRange([start, end]);

            // Example logic for filtering data based on dates
            // Assuming mock data has a `date` field (not present here)
            // Uncomment the below lines if actual `date` field exists in your data
            // const filtered = data.filter((item) => {
            //   const itemDate = moment(item.date); // Replace `item.date` with the actual field
            //   return itemDate.isBetween(start, end, "day", "[]");
            // });
            // setFilteredData(filtered);
        } else {
            setDateRange([]);
            setFilteredData(data);
        }
    };

    const columns = [
        {
            title: "Student Name",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Phone Number",
            dataIndex: "phone",
            key: "phone",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
        },
        {
            title: "College Name",
            dataIndex: "college",
            key: "college",
        },
    ];

    return (
        <div className="p-4">
            {/* Headline */}
            <Title level={3} className="mb-4">
                Super Admin Page
            </Title>

            {/* Date Filter */}
            <Space className="mb-4" direction="vertical" size="middle">
                <span>Filter by Date:</span>
                <RangePicker onChange={handleDateFilter} value={dateRange} />
                <Button onClick={() => handleDateFilter(null)}>Reset Filter</Button>
            </Space>

            {/* Table */}
            <Table
                dataSource={filteredData}
                columns={columns}
                pagination={{
                    pageSize: 5,
                    showSizeChanger: true,
                    pageSizeOptions: ["5", "10", "20"],
                }}
                bordered
            />
        </div>
    );
};

export default SuperAdminPage;
